import { ScrollingModule } from "@angular/cdk/scrolling";
import { CdkTreeModule } from "@angular/cdk/tree";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { TreeModule } from "@circlon/angular-tree-component";
import { NbMomentDateModule } from "@nebular/moment";
import { NbAlertModule, NbButtonModule, NbCardModule, NbCheckboxModule, NbContextMenuModule, NbDatepickerModule, NbFormFieldModule, NbIconModule, NbInputModule, NbListModule, NbSelectModule, NbSpinnerModule, NbStepperModule, NbTooltipModule, NbTreeGridModule } from "@nebular/theme";
import { ThemeModule } from "../../@theme/theme.module";
import { IscanCommmonModule } from "../../common/common.module";
import { ContentReleaseComponent } from "./content-release.component";

const COMPONENTS = [
  ContentReleaseComponent
];
const MODULES = [
  NbCardModule,
  NbInputModule,
  NbIconModule,
  NbButtonModule,
  NbCheckboxModule,
  NbSelectModule,
  NbSpinnerModule,
  NbTooltipModule,
  NbListModule,
  NbFormFieldModule,
  NbDatepickerModule,
  IscanCommmonModule,
  ScrollingModule,
  NbMomentDateModule,
  RouterModule,
  TreeModule,
  FormsModule,
  NbTreeGridModule,
  CdkTreeModule,
  ThemeModule,
  NbContextMenuModule,

  ReactiveFormsModule,
  NbAlertModule,
  NbStepperModule,
];

@NgModule({
  imports: [CommonModule, ...MODULES],
  declarations: [...COMPONENTS],
  exports: [CommonModule, ...COMPONENTS],
  entryComponents: [...COMPONENTS]
})
export class ContentReleaseModule {}